var React = require('react');

function BusinessCardStroke (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#FFFFFF","d":"M132.399,89.099H-3V-3h135.398V89.099z M3,83.099h123.398V3H3V83.099z"})));
}

BusinessCardStroke.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"135.398px","height":"92.1px","viewBox":"-3 -3 135.398 92.1","enableBackground":"new -3 -3 135.398 92.1","xmlSpace":"preserve"};

module.exports = BusinessCardStroke;

BusinessCardStroke.default = BusinessCardStroke;
